module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/expediente-actuacion/expediente-actuacion.component.css
// module id = ./src/app/components/expediente-actuacion/expediente-actuacion.component.css
// module chunks = main